import React, { useState } from "react";
import {
  Box,
  Typography,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  TextField,
  Button,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { StyledButton } from "../../CSS/Styles";

const Templates = () => {
  const [openForm, setOpenForm] = useState(false);
  const [templates, setTemplates] = useState([
    {
      id: 1,
      name: "Welcome Email",
      type: "Email",
      domain: "Marketing",
    },
    {
      id: 2,
      name: "Feedback Form",
      type: "Form",
      domain: "Customer Support",
    },
  ]);
  const [newTemplate, setNewTemplate] = useState({
    name: "",
    type: "",
    domain: "",
  });
  const [editMode, setEditMode] = useState(false);
  const [errors, setErrors] = useState({});

  const validate = () => {
    let tempErrors = {};
    if (!newTemplate.name) tempErrors.name = "Template name is required.";
    if (!newTemplate.type) tempErrors.type = "Template type is required.";
    if (!newTemplate.domain) tempErrors.domain = "Domain is required.";
    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewTemplate((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleOpenForm = () => {
    setOpenForm(true);
    setEditMode(false);
    setNewTemplate({ name: "", type: "", domain: "" });
    setErrors({});
  };

  const handleCloseForm = () => {
    setOpenForm(false);
    setNewTemplate({ name: "", type: "", domain: "" });
    setErrors({});
  };

  const handleSaveTemplate = () => {
    if (validate()) {
      if (editMode) {
        setTemplates((prevTemplates) =>
          prevTemplates.map((template) =>
            template.id === newTemplate.id ? newTemplate : template
          )
        );
      } else {
        setTemplates((prevTemplates) => [
          ...prevTemplates,
          { ...newTemplate, id: Date.now() },
        ]);
      }
      handleCloseForm();
    }
  };

  const handleEdit = (template) => {
    setNewTemplate(template);
    setOpenForm(true);
    setEditMode(true);
  };

  const handleDelete = (id) => {
    setTemplates((prevTemplates) =>
      prevTemplates.filter((template) => template.id !== id)
    );
  };

  return (
    <Box sx={{ padding: 3 }}>
      <Paper elevation={3} sx={{ padding: 3 }}>
        <Box display="flex" justifyContent="flex-start">
          {!openForm && (
            <StyledButton
              sx={{
                marginBottom: 2,
                fontSize: "14px",
                padding: "8px 16px",
              }}
              variant="outlined"
              startIcon={<AddIcon />}
              onClick={handleOpenForm}
            >
              Add Template
            </StyledButton>
          )}
        </Box>

        {!openForm ? (
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Template Name</TableCell>
                  <TableCell>Template Type</TableCell>
                  <TableCell>Domain</TableCell>
                  <TableCell>Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {templates.map((template) => (
                  <TableRow key={template.id}>
                    <TableCell>{template.name}</TableCell>
                    <TableCell>{template.type}</TableCell>
                    <TableCell>{template.domain}</TableCell>
                    <TableCell>
                      <IconButton onClick={() => handleEdit(template)}>
                        <EditIcon />
                      </IconButton>
                      <IconButton onClick={() => handleDelete(template.id)}>
                        <DeleteIcon />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        ) : (
          <Box>
            <Box display="flex" alignItems="center" gap={1} mb={2}>
              <IconButton onClick={handleCloseForm}>
                <ArrowBackIcon />
              </IconButton>
              <Typography variant="h6">
                {editMode ? "Edit Template" : "Add New Template"}
              </Typography>
            </Box>
            <TextField
              label="Template Name"
              name="name"
              value={newTemplate.name}
              onChange={handleInputChange}
              fullWidth
              margin="normal"
              error={!!errors.name}
              helperText={errors.name}
            />
            <TextField
              label="Template Type"
              name="type"
              value={newTemplate.type}
              onChange={handleInputChange}
              fullWidth
              margin="normal"
              error={!!errors.type}
              helperText={errors.type}
            />
            <TextField
              label="Domain"
              name="domain"
              value={newTemplate.domain}
              onChange={handleInputChange}
              fullWidth
              margin="normal"
              error={!!errors.domain}
              helperText={errors.domain}
            />
            <Box sx={{ mt: 3, display: "flex", justifyContent: "flex-end" }}>
              <Button
                onClick={handleCloseForm}
                sx={{ marginRight: 2 }}
                color="error"
                variant="contained"
              >
                Cancel
              </Button>
              <Button
                onClick={handleSaveTemplate}
                color="primary"
                variant="contained"
              >
                Save
              </Button>
            </Box>
          </Box>
        )}
      </Paper>
    </Box>
  );
};

export default Templates;
